import React, { useContext, useState, useEffect } from "react";
import Buttons from "./Buttons";
import {withRouter} from 'react-router-dom'
import MainContext from '../../state/main/mainContext'
import ReactGA from 'react-ga';

const Modal5 = ({ history: {push} }) => {
  const [errorMsg, setErrorMsg] = useState();
  const [seeError, setSeeError] = useState(false);
  const mainContext = useContext(MainContext)
  const {onChange, formData: { firstName, lastName, zipCode }} = mainContext;

  useEffect(() => {
    ReactGA.pageview(window.location.pathname); 
  }, [])

  const moveForward = () => {
    if (
      firstName === "" ||
      lastName === "" ||
      zipCode === null ||
      zipCode === ""
    ) {
      setErrorMsg("Please fill out all fields");
      setSeeError(true);
      console.log({ firstName, lastName, zipCode });
      console.log("wrong");
      return;
    }
    push('/survey/5')
  };
  const preventSubmit = (e) => {
    e.key === "Enter" && e.preventDefault();
  };
  return (
    <section id="modal-5">
      <div className="container">
        <h2 style={{ visibility: "hidden" }}>
          Please tell us a little more about you.
        </h2>
        <h2>Please tell us a little more about you.</h2>
        <div className="form">
          <input
            type="text"
            name="firstName"
            value={firstName}
            onChange={onChange}
            onKeyPress={preventSubmit}
            placeholder="First Name"
          />
          <input
            type="text"
            name="lastName"
            value={lastName}
            onChange={onChange}
            onKeyPress={preventSubmit}
            placeholder="Last Name"
          />
          <input
            type="number"
            name="zipCode"
            value={zipCode}
            onChange={onChange}
            onKeyPress={preventSubmit}
            placeholder="ZIP Code"
          />
          {seeError && <p className="errorMsg">{errorMsg}</p>}
        </div>
        <Buttons advance={moveForward} goBack={() => {push('/survey/3')}}  />
      </div>
    </section>
  );
};

export default withRouter(Modal5);
